import getTouches from './getTouches';
import TweenMax, { Power2 } from "gsap/TweenMax";

class Photos{
    constructor(container){
        this.container = container;
        this.prev = this.container.getElementsByClassName('j-photo-prev')[0];
        this.next = this.container.getElementsByClassName('j-photo-next')[0];
        this.items = this.container.getElementsByClassName('j-photo-item');
        this.close = this.container.getElementsByClassName('j-photo-close')[0];
        this.busy = false;

        this.init();
    }

    init(){
        const cmp = this;

        const openers = document.getElementsByClassName('j-photo-open');
        for(let i=0; i<openers.length; i++){
            openers[i].addEventListener('click', function(e){
                const $this = this;
                for(let j=0; j<cmp.items.length; j++){
                    if(cmp.items[j].getAttribute('id') === $this.getAttribute('data-id')){
                        cmp.items[j].classList.add('_current-photo');
                        cmp.items[j].classList.remove('_ani-in');
                        cmp.items[j].classList.remove('_ani-out');
                        document.getElementsByClassName('j-photo-back')[0].classList.add('_vis');
                        document.getElementsByClassName('j-photo-close')[0].classList.remove('_vis');
                        if(j > 0){
                            cmp.prev.disabled = false;
                        }
                        else{
                            cmp.prev.disabled = true;
                        }
                        if(j < cmp.items.length-1){
                            cmp.next.disabled = false;
                        }
                        else{
                            cmp.next.disabled = true;
                        }
                    }
                    else{
                        cmp.items[j].classList.remove('_current-photo');
                        cmp.items[j].classList.remove('_ani-in');
                        cmp.items[j].classList.remove('_ani-out');
                    }
                }
                document.dispatchEvent(new CustomEvent('page.change', {'detail': {'current':'pageGallery','direction':'to','towhat':'pagePhoto'}}));
            });
        }

        const showers = document.getElementsByClassName('j-photo-show');
        for(let i=0; i<showers.length; i++){
            showers[i].addEventListener('click', function(e){
                const $this = this;
                for(let j=0; j<cmp.items.length; j++){
                    if(cmp.items[j].getAttribute('id') === $this.getAttribute('data-id')){
                        cmp.items[j].classList.add('_current-photo');
                        cmp.items[j].classList.remove('_ani-in');
                        cmp.items[j].classList.remove('_ani-out');
                        document.getElementsByClassName('j-photo-back')[0].classList.remove('_vis');
                        document.getElementsByClassName('j-photo-close')[0].classList.add('_vis');
                        if(j > 0){
                            cmp.prev.disabled = false;
                        }
                        else{
                            cmp.prev.disabled = true;
                        }
                        if(j < cmp.items.length-1){
                            cmp.next.disabled = false;
                        }
                        else{
                            cmp.next.disabled = true;
                        }
                    }
                    else{
                        cmp.items[j].classList.remove('_current-photo');
                        cmp.items[j].classList.remove('_ani-in');
                        cmp.items[j].classList.remove('_ani-out');
                    }
                }
                cmp.busy = true;
                TweenMax.fromTo(
                    `#pagePhoto`,
                    0.5,
                    {
                        height: 0,
                        opacity: 1,
                        zIndex: 10
                    },
                    {
                        ease: Power2.easeOut,
                        height: '100%',
                        opacity: 1,
                        zIndex: 10,
                        onComplete: () => {
                            document.getElementById('pagePhoto').classList.add('_current');
                            document.getElementById('pagePhoto').classList.add('_animation-in');
                            document.getElementsByClassName('_current-photo')[0].classList.add('_ani-in');
                            cmp.busy = false;
                        }
                    }
                );
            });
        }

        cmp.close.addEventListener('click', function(){
            cmp.busy = true;
            document.getElementById('pagePhoto').classList.add('_animation-out');
            TweenMax.fromTo(
                `#pagePhoto`,
                0.5,
                {
                    height: '100%',
                    opacity: 1,
                    zIndex: 10
                },
                {
                    ease: Power2.easeOut,
                    height: 0,
                    opacity: 1,
                    zIndex: 10,
                    onComplete: () => {
                        document.getElementById('pagePhoto').classList.remove('_current');
                        document.getElementById('pagePhoto').classList.remove('_animation-in');
                        document.getElementById('pagePhoto').classList.remove('_animation-out');
                        document.getElementById('pagePhoto').removeAttribute('style');
                        document.getElementsByClassName('_current-photo')[0].classList.remove('_ani-in');
                        document.getElementsByClassName('_current-photo')[0].classList.remove('_ani-out');
                        cmp.busy = false;
                    }
                }
            );
        });

        cmp.prev.addEventListener('click', function(){
            if(!cmp.busy){
                let current = null;
                let prev = null;
                let prevI = -1;
                for(let i=0; i<cmp.items.length; i++){
                    if(cmp.items[i].classList.contains('_current-photo')){
                        current = cmp.items[i];
                        if(i>0){
                            prev = cmp.items[i-1];
                            prevI = i-1;
                        }
                    }
                }
                if(prev){
                    if(prevI > 0){
                        cmp.prev.disabled = false;
                    }
                    else{
                        cmp.prev.disabled = true;
                    }
                    cmp.next.disabled = false;
                    current.classList.add('_ani-out');
                    TweenMax.fromTo(
                        `#${current.getAttribute('id')}`,
                        0.5,
                        {
                            left: 0,
                            opacity: 1
                        },
                        {
                            left: '100%',
                            opacity: 1,
                            ease: Power2.easeOut,
                            delay: 0.35,
                            onComplete: () => {
                                current.classList.remove('_current-photo');
                                current.classList.remove('_ani-in');
                                current.classList.remove('_ani-out');
                                current.removeAttribute('style');
                            }
                        }
                    );
                    TweenMax.fromTo(
                        `#${prev.getAttribute('id')}`,
                        0.5,
                        {
                            left: '-100%',
                            opacity: 1
                        },
                        {
                            left: 0,
                            opacity: 1,
                            ease: Power2.easeOut,
                            delay: 0.45,
                            onComplete: () => {
                                prev.classList.add('_current-photo');
                                prev.classList.add('_ani-in');
                                prev.removeAttribute('style');
                                cmp.busy = false;
                            }
                        }
                    );
                }
                else{
                    cmp.busy = false;
                }
            }
        });

        cmp.next.addEventListener('click', function(){
            if(!cmp.busy){
                let current = null;
                let next = null;
                let nextI = cmp.items.length;
                for(let i=0; i<cmp.items.length; i++){
                    if(cmp.items[i].classList.contains('_current-photo')){
                        current = cmp.items[i];
                        if(i<cmp.items.length - 1){
                            next = cmp.items[i+1];
                            nextI = i+1;
                        }
                    }
                }
                if(next){
                    if(nextI < cmp.items.length-1){
                        cmp.next.disabled = false;
                    }
                    else{
                        cmp.next.disabled = true;
                    }
                    cmp.prev.disabled = false;
                    current.classList.add('_ani-out');
                    TweenMax.fromTo(
                        `#${current.getAttribute('id')}`,
                        0.5,
                        {
                            left: 0,
                            opacity: 1
                        },
                        {
                            left: '-100%',
                            opacity: 1,
                            ease: Power2.easeOut,
                            delay: 0.35,
                            onComplete: () => {
                                current.classList.remove('_current-photo');
                                current.classList.remove('_ani-in');
                                current.classList.remove('_ani-out');
                                current.removeAttribute('style');
                            }
                        }
                    );
                    TweenMax.fromTo(
                        `#${next.getAttribute('id')}`,
                        0.5,
                        {
                            left: '100%',
                            opacity: 1
                        },
                        {
                            left: 0,
                            opacity: 1,
                            ease: Power2.easeOut,
                            delay: 0.45,
                            onComplete: () => {
                                next.classList.add('_current-photo');
                                next.classList.add('_ani-in');
                                next.removeAttribute('style');
                                cmp.busy = false;
                            }
                        }
                    );
                }
                else{
                    cmp.busy = false;
                }
            }
        });

        var xDown = null;                                                        
        var yDown = null;

        cmp.container.addEventListener('touchstart', function(evt){
            var firstTouch = getTouches(evt)[0];
            xDown = firstTouch.clientX;
            yDown = firstTouch.clientY;
        }, false);        
        cmp.container.addEventListener('touchmove', function(evt){
            if ( ! xDown || ! yDown ) {
                return;
            }    
            var xUp = evt.touches[0].clientX;                                    
            var yUp = evt.touches[0].clientY;    
            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;    
            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
                if ( xDiff > 0 ) {
                    if(!cmp.busy){
                        cmp.busy = true;
                        let current = null;
                        let next = null;
                        let nextI = cmp.items.length;
                        for(let i=0; i<cmp.items.length; i++){
                            if(cmp.items[i].classList.contains('_current-photo')){
                                current = cmp.items[i];
                                if(i<cmp.items.length - 1){
                                    next = cmp.items[i+1];
                                    nextI = i+1;
                                }
                            }
                        }
                        if(next){
                            if(nextI < cmp.items.length-1){
                                cmp.next.disabled = false;
                            }
                            else{
                                cmp.next.disabled = true;
                            }
                            cmp.prev.disabled = false;
                            current.classList.add('_ani-out');
                            TweenMax.fromTo(
                                `#${current.getAttribute('id')}`,
                                0.5,
                                {
                                    left: 0,
                                    opacity: 1
                                },
                                {
                                    left: '-100%',
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.35,
                                    onComplete: () => {
                                        current.classList.remove('_current-photo');
                                        current.classList.remove('_ani-in');
                                        current.classList.remove('_ani-out');
                                        current.removeAttribute('style');
                                    }
                                }
                            );
                            TweenMax.fromTo(
                                `#${next.getAttribute('id')}`,
                                0.5,
                                {
                                    left: '100%',
                                    opacity: 1
                                },
                                {
                                    left: 0,
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.45,
                                    onComplete: () => {
                                        next.classList.add('_current-photo');
                                        next.classList.add('_ani-in');
                                        next.removeAttribute('style');
                                        cmp.busy = false;
                                    }
                                }
                            );
                        }
                        else{
                            cmp.busy = false;
                        }
                    }
                } else {
                    if(!cmp.busy){
                        cmp.busy = true;
                        let current = null;
                        let prev = null;
                        let prevI = -1;
                        for(let i=0; i<cmp.items.length; i++){
                            if(cmp.items[i].classList.contains('_current-photo')){
                                current = cmp.items[i];
                                if(i>0){
                                    prev = cmp.items[i-1];
                                    prevI = i-1;
                                }
                            }
                        }
                        if(prev){
                            if(prevI > 0){
                                cmp.prev.disabled = false;
                            }
                            else{
                                cmp.prev.disabled = true;
                            }
                            cmp.next.disabled = false;
                            current.classList.add('_ani-out');
                            TweenMax.fromTo(
                                `#${current.getAttribute('id')}`,
                                0.5,
                                {
                                    left: 0,
                                    opacity: 1
                                },
                                {
                                    left: '100%',
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.35,
                                    onComplete: () => {
                                        current.classList.remove('_current-photo');
                                        current.classList.remove('_ani-in');
                                        current.classList.remove('_ani-out');
                                        current.removeAttribute('style');
                                    }
                                }
                            );
                            TweenMax.fromTo(
                                `#${prev.getAttribute('id')}`,
                                0.5,
                                {
                                    left: '-100%',
                                    opacity: 1
                                },
                                {
                                    left: 0,
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.45,
                                    onComplete: () => {
                                        prev.classList.add('_current-photo');
                                        prev.classList.add('_ani-in');
                                        prev.removeAttribute('style');
                                        cmp.busy = false;
                                    }
                                }
                            );
                        }
                        else{
                            cmp.busy = false;
                        }
                    }
                }                       
            } else {
                if ( yDiff > 0 ) { } else { }                                                                 
            }
            xDown = null;
            yDown = null;
        }, false);
    }
}
document.addEventListener('keyup', (e) =>{ if(e.keyCode==39){document.getElementsByClassName("j-photo-next")[0].click()}
else if(e.keyCode==37){document.getElementsByClassName("j-photo-prev")[0].click()
}})

export default Photos;